import { render, staticRenderFns } from "./VideoHistoryPlayerV2.vue?vue&type=template&id=cc6b379a&"
import script from "./VideoHistoryPlayerV2.vue?vue&type=script&lang=js&"
export * from "./VideoHistoryPlayerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports